<template>
  <div style="">
    <swiper class="swiper" :options="swiperOptions" v-if="data.length">
      <swiper-slide class="swiperitem" :ref="'iconFestivalItem'+index" v-for="(item,index) in data" :key="item.id"
        :data-attrsid="item.opusattrid">
        <template>
          <!-- 标签气泡 -->
          <div ref="iconBubblesWrap" class="iconBubbles-wrap" v-show="iconBubblesShow">
            <div class="frame">
              {{iconBubblesText}}
              <span class="triangle"></span>
            </div>
          </div>
          <!-- 标签气泡 -->
          <div class="imgView" @click="toWorkDetail(item, 'list')">
            <img :src="item.imgurl" alt="" />
            <!-- <div class="shadowBg"></div> -->
          </div>
          <div>
            <div class="title"><span>{{ item.workName }}</span><img class="icon-festival" :ref="'iconFestival'+index"
                @click.stop="festivalClick(icons.detail,'iconFestival',index,'iconFestivalItem')"
                :src="$baseUrl+icons.icon" alt="" v-for="icons in item.opustag" :key="icons.key"></div>
            <div class="introView">
              <div v-if="item.workIntroSub" class="intro">{{ item.workIntroSub }}</div>
              <div v-if="item.codeshow">{{item.codeshow}}</div>
              <!-- <div class="code">#{{ item.workCode }}/{{ item.qty }}</div> -->
            </div>
          </div>
        </template>
      </swiper-slide>
    </swiper>
    <!-- 标签气泡 -->
    <iconBubbles ref="iconBubbles"></iconBubbles>
  </div>
</template>
<script>
  import Vue from "vue";
  import VueAwesomeSwiper from "vue-awesome-swiper";
  // import "swiper/dist/css/swiper.css";
  import {
    swiper,
    swiperSlide
  } from "vue-awesome-swiper";
  Vue.use(VueAwesomeSwiper);
  import iconBubbles from "@/components/iconBubbles.vue";
  export default {
    components: {
      iconBubbles
    },
    props: {
      data: {
        type: Array,
        default: () => {
          return [];
        },
      },
    },
    data() {
      return {
        swiperOptions: {
          effect: 'coverflow',
          grabCursor: true,
          centeredSlides: true,
          slidesPerView: 'auto',
          coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          },
        },
        iconBubblesShow: false, //当前标签需要展示气泡
        iconBubblesText: '', //当前标签需要展示气泡
        timer: null,
      };
    },
    methods: {
      festivalClick(text, ref, idx, parent) {
        if (this.timer) clearTimeout(this.timer)
        this.iconBubblesShow = true;
        this.iconBubblesText = text;
        this.timer = setTimeout(() => {
          this.iconBubblesShow = false;
        }, 1500)
      },
      toWorkDetail(item, list) {
        console.log(item);
        this.$emit("toDetail", item, "list");
      },

    },
    mounted() {
      let that = this;
    },
  };

</script>
<style scoped lang="less">
  @import '../../static/css/iconBubbles.css';

  .swiper {
    -webkit-overflow-scrolling: touch;
  }

  .bgImg(@w, @h, @bg) {
    width: @w;
    height: @h;
    background: url(@bg);
    background-size: 100% 100%;
  }

  .swiper {
    width: 100%;

    .swiper-slide-active {
      background: none;
    }

    .swiper-slide {
      position: relative;
      width: 266px;
      // height: 300px;
      // background: red;

      .iconBubbles-wrap {
        position: absolute;
        z-index: 999;
        display: inline-block;
        text-align: right;
        right: 120px;
        top: 190px;



      }

      .imgView {
        height: 201px;
        // background: #0b0b0b;
        border-radius: 7.5px;
        border: 1px solid #47475d;
        width: 266px;
        // height: 262.5px;
        margin: 0 auto;
        text-align: center;
      }

      img {
        object-fit: cover;
        width: 245px;
        height: 177.5px;
        opacity: 0.4;
        margin-top: 11.75px;
        border-radius: 6px;
      }

      .shadowBg {
        height: 66px;
        background: url(/static/img/profile/flurBg.png);
        background-size: 100% 100%;
        // background: linear-gradient(
        //   180deg,
        //   #1ce89e 0%,
        //   rgba(60, 245, 205, 0) 100%
        // );
        // filter: blur(14.976px);
        // border-radius: 50%;
      }

      .title {
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        margin-top: 31.5px;

        span {
          display: inline-block;
          vertical-align: middle;
        }

        .icon-festival {
          display: none;
          width: 22px;
          height: 22px;
          border-radius: 50%;
          vertical-align: middle;
          margin: 0 0 0 5px;
        }
      }

      .introView {
        text-align: center;
      }

      .intro {
        margin-top: 7px;
        text-align: center;
        // display: inline-block;
        font-size: 13px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #83878B;
        margin-bottom: 18px;
      }

      // .code{
      //   display: inline-block;
      //   position: relative;
      // }
      .code {
        display: inline-block;
        position: relative;
        top: -1px;
        min-width: 20px;
        height: 28px;
        line-height: 28px;
        background: url(../../static/img/work/code-c1.png) repeat-x center center;
        background-size: 100% 100%;
        color: #0FB093;
        margin: 0 10px 0;

        // padding: 2px 0 0 0;
        &::before {
          position: absolute;
          left: -9.5px;
          top: 0;
          display: inline-block;
          content: "";
          .bgImg(16.5px, 28px, "../../static/img/work/code-l1.png");
        }

        &::after {
          position: absolute;
          right: -10.5px;
          top: 0;
          display: inline-block;
          content: "";
          .bgImg(16.5px, 28px, "../../static/img/work/code-r1.png");
        }
      }
    }

    .swiper-slide-active {
      img {
        opacity: 1;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/openBoxSwiperApp.vue